import React, { FC } from "react";
import { FieldArray } from "react-final-form-arrays";
import { Field, useForm } from "react-final-form";
import { Grid, makeStyles } from "@material-ui/core";
import Button from "../../../../../components/Button";
import BootstrapInput from "../../../../../components/BootstrapInput";
import ShowCurrency from "./ShowCurrency";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import { ICourseComponentProps } from "../../../types";

const useStyles = makeStyles(() => ({
  buttonContainer: {
    textAlign: "right",
    marginTop: 12,
  },
  button: {
    fontSize: 17,
    fontWeight: "bold",
    height: 44,
    color: "#fefefe",
    backgroundColor: "#7ec884",
    width: 195,
    padding: "0 10px!important",
  },
  fieldArrayContainer: {
    display: "flex",
    flexDirection: "column-reverse",
  },
  elementContainer: {
    marginTop: 16,
  },
}));

interface IOtherFeesProps extends ICourseComponentProps {
  infoText?: string;
  currency: string;
}

const OtherFees: FC<IOtherFeesProps> = ({
  fieldsGroupName,
  infoText = "",
  currency,
}) => {
  const classes = useStyles();

  const {
    mutators: { push },
  } = useForm();

  return (
    <div>
      <FieldsGroupLabel
        label="Other Fees"
        className="fields-group-label"
        infoText={infoText}
      />
      <div className={classes.buttonContainer}>
        <Button
          color={"success"}
          fullWidth
          onClick={() => push(`${fieldsGroupName}.addedOtherFees`, undefined)}
          variant="contained"
          className={classes.button}
        >
          Add Other Fees
        </Button>
      </div>
      <div className={classes.fieldArrayContainer}>
        <FieldArray name={`${fieldsGroupName}.addedOtherFees`}>
          {({ fields }) =>
            fields.map((name) => (
              <div key={name} className={classes.elementContainer}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={4}>
                    <Field
                      fullWidth
                      type="text"
                      label="Other Fee"
                      placeholder="Name of other fee"
                      name={`${name}.name`}
                      component={BootstrapInput}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <Field
                      fullWidth
                      type="text"
                      label="Amount"
                      placeholder="Amount"
                      name={`${name}.amount`}
                      component={BootstrapInput}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <ShowCurrency currency={currency} />
                  </Grid>
                </Grid>
              </div>
            ))
          }
        </FieldArray>
      </div>
      <div className={classes.elementContainer}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={4}>
            <Field
              fullWidth
              type="text"
              label="Other Fee"
              placeholder="Name of other fee"
              name={`${fieldsGroupName}.mainOtherFees.0.name`}
              component={BootstrapInput}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Field
              fullWidth
              type="text"
              label="Amount"
              placeholder="Amount"
              name={`${fieldsGroupName}.mainOtherFees.0.amount`}
              component={BootstrapInput}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <ShowCurrency currency={currency} />
          </Grid>
        </Grid>
      </div>
      <div className={classes.elementContainer}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={4}>
            <Field
              fullWidth
              type="text"
              label="Other Fee"
              placeholder="Name of other fee"
              name={`${fieldsGroupName}.mainOtherFees.1.name`}
              component={BootstrapInput}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Field
              fullWidth
              type="text"
              label="Amount"
              placeholder="Amount"
              name={`${fieldsGroupName}.mainOtherFees.1.amount`}
              component={BootstrapInput}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <ShowCurrency currency={currency} />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default React.memo(OtherFees);
